export const TRANSFER_CONSENT_DOCS = {
  termsOfService: {
    labelKey: 'billing.transferSetup.consent.termsOfService',
    urlKey: 'terms_of_service',
  },
  privacyPolicy: {
    labelKey: 'billing.transferSetup.consent.privacyPolicy',
    urlKey: 'privacy_policy',
  },
  consentToTreatment: {
    labelKey: 'billing.transferSetup.consent.consentToTreatment',
    urlKey: 'consent_to_treatment',
  },
  hipaaNotice: {
    labelKey: 'billing.transferSetup.consent.hipaaNotice',
    urlKey: 'hipaa_notice',
  },
};

export function consentDocsForUrls(urls) {
  let overlay = urls || {};

  return Object.entries(TRANSFER_CONSENT_DOCS).map(([key, doc]) => ({
    key,
    labelKey: doc.labelKey,
    url: overlay[doc.urlKey],
  }));
}
